import styled from '@emotion/native'
import webStyled from '@emotion/styled'
import { Text } from '@ui/components'
import { View } from 'react-native'

export const ContainerVaccines = styled.ScrollView(({ theme }) => ({
  flex: 1,
  gap: theme.sizes.sm,
  marginBottom: theme.sizes.md,
  width: '100%',
}))

export const Container = styled.View(({ theme }) => ({
  flex: 1,
  padding: theme.sizes.xs,
  paddingTop: 0,
  gap: theme.sizes.sm,
}))

export const NameContainer = styled.View(({ }) => ({
  alignItems: 'center',
  width: '100%',
}))

export const NameText = styled(Text)(({ }) => ({
  margin: 0,
  padding: 0,
}))
export const HeaderContainer = styled.View(({ theme }) => ({
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const NoVaccinesTextContainer = styled.View(({ theme }) => ({
  backgroundColor: 'blue',
  width: '100%',
  height: '100%',
}))

export const ButtonsContainer = styled.View(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
  gap: theme.sizes.sm,
}))

export const PictureContainer = styled(View)<{ width: number; aspectRatio: number }>(({ theme, width, aspectRatio }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  width: width,
  height: width,
  borderColor: '#ECECEC',
  borderWidth: 3,
  borderRadius: 100,
  margin: 5,
}))

export const PetImage = webStyled.img(({ theme }) => ({
  margin: '5%',
  padding: 0,
  with: '100%',
  height: '100%',
  objectFit: 'contain',
  backgroundColor: 'red',
  borderRadius: 100,
}))

export const ButtonContainer = styled.View(({ theme }) => ({
  marginLeft: 'auto',
  justifyContent: 'center',
}))

export const WarningContainer = styled.View(({ theme }) => ({
  backgroundColor: '#ff9800',
  borderColor: '#e65100',
  borderWidth: 1,
  borderRadius: 8,
  padding: theme.sizes.sm,
  marginBottom: theme.sizes.sm,
  width: '100%',
}))

export const TableHeader = styled.View(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  paddingVertical: 12,
  paddingHorizontal: 16,
  backgroundColor: '#f5f5f5',
  borderBottomWidth: 2,
  borderBottomColor: '#e0e0e0',
  gap: 16,
  flexWrap: 'wrap',
}))

export const TableRow = styled.TouchableOpacity(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  paddingVertical: 12,
  paddingHorizontal: 16,
  borderBottomWidth: 1,
  borderBottomColor: '#e0e0e0',
  gap: 16,
  flexWrap: 'wrap',
}))

export const StatusColumn = styled.View(() => ({
  minWidth: 50,
  alignItems: 'center',
  justifyContent: 'center',
}))

export const TypeColumn = styled.View(() => ({
  minWidth: 50,
  alignItems: 'center',
  justifyContent: 'center',
}))

export const VaccineColumn = styled.View(() => ({
  flex: 1,
  minWidth: 150,
}))

export const PeriodicityColumn = styled.View(() => ({
  minWidth: 100,
  alignItems: 'center',
}))

export const RenewalColumn = styled.View(() => ({
  minWidth: 140,
  alignItems: 'flex-end',
}))

export const HistoryColumn = styled.View(() => ({
  minWidth: 120,
  alignItems: 'flex-end',
}))

export const MobileCard = styled.View(() => ({
  backgroundColor: 'white',
  borderRadius: 8,
  padding: 16,
  marginBottom: 8,
  borderWidth: 1,
  borderColor: '#e0e0e0',
}))

export const MobileCardHeader = styled.View(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: 8,
  gap: 12,
}))

export const MobileCardContent = styled.View(() => ({
  gap: 4,
}))

export const MobileCardRow = styled.View(() => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

export const StatusCircle = styled.View<{ isMandatory: boolean; isUpToDate: boolean }>(({ isMandatory, isUpToDate }) => ({
  width: 24,
  height: 24,
  borderRadius: 12,
  backgroundColor: isMandatory ? '#ff9800' : '#9e9e9e',
  alignItems: 'center',
  justifyContent: 'center',
  borderWidth: 2,
  borderColor: isUpToDate ? '#4caf50' : '#f44336',
}))
